export default __webpack_public_path__ + "static/fitbit-8bd11dac2ebb0e5c0ca5e4f7a455f1a2.svg";